import { generateKeys } from '../utils';
export const salesAgentTypes = generateKeys({
    retention: {
        value: 'retention',
        label: 'Retention',
    },
    conversion: {
        value: 'conversion',
        label: 'Conversion',
    },
    hybrid: {
        value: 'hybrid',
        label: 'Hybrid',
    },
});
export const userDepartments = generateKeys({
    system: {
        value: 'system',
        label: 'System',
    },
    boFunding: {
        value: 'boFunding',
        label: 'Back Office Funding',
    },
    boAccountOpening: {
        value: 'boAccountOpening',
        label: 'Back Office Account Opening',
    },
    salesOperations: {
        value: 'salesOperations',
        label: 'Sales Operations',
    },
    marketing: {
        value: 'marketing',
        label: 'Marketing',
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
    },
    sales: {
        value: 'sales',
        label: 'Sales',
    },
    support: {
        value: 'support',
        label: 'Support',
    },
    development: {
        value: 'development',
        label: 'Development/IT',
    },
    accounting: {
        value: 'accounting',
        label: 'Accounting',
    },
    humanResources: {
        value: 'humanResources',
        label: 'HR',
    },
    businessIntelligence: {
        value: 'businessIntelligence',
        label: 'Business Intelligence',
    },
    projectManagement: {
        value: 'projectManagement',
        label: 'Project Management',
    },
    office: {
        value: 'office',
        label: 'Office',
    },
    management: {
        value: 'management',
        label: 'Management',
    },
    seniorManagement: {
        value: 'seniorManagement',
        label: 'Senior Management',
    },
    shareholder: {
        value: 'shareholder',
        label: 'Shareholder',
    },
    dealing: {
        value: 'dealing',
        label: 'Dealing',
    },
    directorOfOperations: {
        value: 'directorOfOperations',
        label: 'Director of Operations',
    },
    administration: {
        value: 'administration',
        label: 'Administration',
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate',
    },
    bdx: {
        value: 'bdx',
        label: 'BDX',
    },
    callMonitoring: {
        value: 'callMonitoring',
        label: 'Call Monitoring',
    },
    customerRelations: {
        value: 'customerRelations',
        label: 'Customer Relations',
    },
    contractor: {
        value: 'contractor',
        label: 'Contractor',
    },
    it: {
        value: 'it',
        label: 'IT',
    },
    businessDevelopment: {
        value: 'businessDevelopment',
        label: 'Business Development',
    },
    paymentSolutions: {
        value: 'paymentSolutions',
        label: 'Payment Solutions',
    },
    portfolio: {
        value: 'portfolio',
        label: 'Portfolio Management',
    },
    receiption: {
        value: 'receiption',
        label: 'Reception and Transmission',
    },
    risk: {
        value: 'risk',
        label: 'Risk Management',
    },
    retention: {
        value: 'retention',
        label: 'Retention',
    },
    investment: {
        value: 'investment',
        label: 'Investment Research',
    },
    clientRelationsTraining: {
        value: 'clientRelationsTraining',
        label: 'Client Relations Training',
    },
    complaints: {
        value: 'complaints',
        label: 'Complaints',
    },
    partnershipOperations: {
        value: 'partnershipOperations',
        label: 'Partnership Operations',
    },
    businessTransformation: {
        value: 'businessTransformation',
        label: 'Business Transformation',
    },
});
export const departmentRoles = generateKeys({
    head: {
        value: 'head',
        label: 'Head of Department',
    },
    assistantHead: {
        value: 'assistantHead',
        label: 'Assistant Head',
    },
    employee: {
        value: 'employee',
        label: 'Employee',
    },
});
